
import SearchCustom from "../../../components/custom/search-custom";

interface PromotionCampaignFilterProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

export const PromotionCampaignFilter = ({
  searchValue,
  setSearchValue,
}: PromotionCampaignFilterProps) => {

  return (
    <div
      className="flex flex-wrap md:flex-row justify-end gap-4 md:gap-8"
      id="filter-bar"
    >
      <div className="w-full md:w-auto md:mt-0">
        <SearchCustom
          value={searchValue}
          onChange={(e) => setSearchValue(e)}
          className="w-full md:w-64"
        />
      </div>
    </div>
  );
};

